<template>
  <div class="news_recommend_content">
    <div class="news_recommend_head">
      <h3>{{ title }}企业</h3>
      <!-- <span>{{newsRecommendObj.text}}</span> -->
    </div>
    <ul>
      <li
        @click="toDetail(item)"
        v-for="(item, index) in companyList"
        :key="index"
      >
        <!-- {{ item.lable }} -->
        <p>{{ item.name }}</p>
        <span>地址：{{ item.address }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { routerGoNewpage } from "@/utils/index";
import { getCompanyList } from "@/api/information";
export default {
  props: {
    title: {
      type: String,
    },
    category: {
      type: Number,
    },
  },
  data() {
    return {
      companyList: [],
    };
  },
  watch: {
    category: {
      handler: function (val) {
        this.tgetCompanyList(val);
      },
      immediate: true,
    },

  },
  methods: {
    toDetail(item) {
      sessionStorage.setItem("corporateId", item.userId);
      this.$store.dispatch("company/getBaseInfo");
      routerGoNewpage("/corporate_detail", {
        id: item.userId,
      });
    },
    //获取企业列表
    tgetCompanyList(category) {
      getCompanyList({
        weight: 0,
        limit: 5,
        curPage: 1,
        industry: category,
      }).then((res) => {
        this.companyList = res.data.list;
      });
    },
  },
};
</script>

<style scoped lang="less">
.news_recommend_content {
  background: #f8f8f8;
  border-top: 2px solid #9ad02a;
  padding: 16px;
  width: 259px;
  .news_recommend_head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px dashed #e1e1e1;
    padding-bottom: 15px;
    span {
      cursor: pointer;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #9a9a9a;
      &::before {
        display: inline-block;
        content: "";
        width: 17px;
        height: 17px;
        background: url("../assets/images/update.jpg") no-repeat center/100%;
        vertical-align: top;
        margin-right: 3px;
      }
    }
  }
  img {
    width: 100%;
    height: 168px;
    margin: 15px 0 0;
  }
  ul {
    li {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #343434;
      padding: 10px 0;
      border-bottom: 1px dashed #e1e1e1;
      cursor: pointer;
      &:last-of-type {
        padding-bottom: 0;
        border-bottom: 0;
      }
      p {
        margin-bottom: 5px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        display: inline-block;
        width: 93%;
        // 单行溢出省略
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        width: 93%;
        display: inline-block;
        // 单行溢出省略
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        // word-wrap:break-word
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/newsRecommends.vue